(function () {
	'use strict';
	angular.module('app.dashboard')
		.directive('dashboardFunctions', dashboardFunctions);

	dashboardFunctions.$inject = [];
	function dashboardFunctions() {
		return {
			restrict: 'EA',
			templateUrl: '/application/f/dashboard/dashboard-functions.html',
			scope: {
				model: '=',
				dashboardView: '=',
				useReportHeaderButtons: '=',
				showSaveReport: '='
			},
			controller: dashboardFunctionsCtrl,
			controllerAs: 'dashboardFunctionsCtrl',
			bindToController: true
		};
	}

	dashboardFunctionsCtrl.$inject = ['$rootScope', '$scope', '$window', '$uibModal', '$state', '$timeout',
		'$http', '$translate', 'dashboardService', 'navigationService', 'adfTemplatePath',
		'storeService', 'dashboardCreationService', 'leanFilterService', 'userConfigUtilsService', 'URLS', '$experiments'];
	function dashboardFunctionsCtrl($rootScope, $scope, $window, $uibModal, $state, $timeout, $http, $translate,
			dashboardService, navigationService, adfTemplatePath,
			storeService, dashboardCreationService, leanFilterService, userConfigUtilsService, URLS, $experiments) {
		var vm = this;
		$scope.toggleSelection = function (e) {
			if (e) e.stopPropagation();
			$scope.showDropDown = !$scope.showDropDown;
			if ($scope.showDropDown) {
				if ($scope.showViewDropDown) {
					$scope.toggleViewSelection(e);
				}
				$window.onclick = function (e) {
					var target = jQuery(e.target);
					if (target.length === 0) return;
					if (!target.hasClass('showDropDown')) {
						$scope.toggleSelection();
					}
				};
			} else if (!e) {
				$window.onclick = null;
				$scope.$apply();
			}
		};


		$scope.toggleViewSelection = function (e) {
			if (e) e.stopPropagation();
			$scope.showViewDropDown = !$scope.showViewDropDown;
			if ($scope.showViewDropDown) {
				if ($scope.showDropDown) {
					$scope.toggleSelection(e);
				}
				$window.onclick = function (e) {
					var target = jQuery(e.target);
					if (target.length === 0) return;
					if (!target.hasClass('showViewDropDown')) {
						$scope.toggleViewSelection();
					}
				};
			} else if (!e) {
				$window.onclick = null;
				$scope.$apply();
			}
		};

		$scope.addNewDashboardDialog = function () {
			var addDashboardScope = $scope.$new();
			var dashboard = {};
			dashboard.header = 'Create New Dashboard';
			addDashboardScope.title = 'Title';
			dashboard.title = '';
			dashboard.description = '';
			$scope.dashboard = dashboard;
			$scope.isEdit = false;
			$http.get(String.format(URLS.dashboards, globalConfig.customer.id)).then(
				function (response) {
					var emptyOption = {
						id: -1,
						name: 'Choose a dashboard',
						description: ''
					};
					var isCtbSingleLevelEnabled = userConfigUtilsService.getClearToBuildSingleLevelEnabledForUser();
					var isCtbMultiLevelEnabled = userConfigUtilsService.getClearToBuildMultiLevelEnabledForUser();
					var plannerPerformanceSingleLevelIdx = -1;
					var plannerPerformanceMultiLevelIdx = -1;
					$scope.dashboards = dashboardService.moveEmptyToEndOfList(response.data);
					for(var i=0; i < $scope.dashboards.length; i++){
						if($scope.dashboards[i].name === 'Planner Performance (Single Level)'){
							plannerPerformanceSingleLevelIdx = i;
						}
						if($scope.dashboards[i].name === 'Planner Performance (Multi Level)'){
							plannerPerformanceMultiLevelIdx = i;
						}
					}
					if(!isCtbSingleLevelEnabled){
						$scope.dashboards.splice(plannerPerformanceSingleLevelIdx, 1);
					}
					if(!isCtbMultiLevelEnabled){
						$scope.dashboards.splice(plannerPerformanceMultiLevelIdx, 1);
					}
					if ($scope.dashboards.length > 0) {
						$scope.dashboards.unshift(emptyOption);
						$scope.dashboard.startwith = $scope.dashboards[0];
					}
				},
				function (error) { }
			);
			var instance = $uibModal.open({
				scope: addDashboardScope,
				templateUrl: adfTemplatePath + 'dashboard-edit.html'
			});
			focus('dashboardName');
			addDashboardScope.closeDialog = function () {
				instance.close();
				addDashboardScope.$destroy();
			};
			addDashboardScope.startWithChange = function () {
				if ($scope.dashboard.startwith.id !== -1) {
					$scope.dashboard.title = $translate.instant($scope.dashboard.startwith.name);
					$scope.dashboard.startWithError = false;
				} else {
					$scope.dashboard.startWithError = true;
					$scope.dashboard.title = '';
				}
			};
			addDashboardScope.addDashboard = function () {
				var dd = $scope.dashboard;
				var startwith = {};
				if (dd.startwith) {
					startwith = dd.startwith;
				}
				var isXMatrix = startwith && startwith.config.includes('"type":"xMatrix"');
				var defaultFactoryFilter = !isXMatrix ? leanFilterService.leanDnaAllSelected : globalConfig.factory.id;
				var filters =[{id: 'factory', values: [defaultFactoryFilter]}];
				if(startwith.name === 'Planner Performance (Single Level)' || startwith.name === 'Planner Performance (Multi Level)'){
					filters.push(
						{
							id: 'ctbTimePeriod',
							values: ['ctbWindow'],
							comparator: leanFilterService.comparatorsMap.ctbWindow
						}
					);
				}

				var newDashboard = {
					reportName: dd.title,
					baseReportName: startwith ? startwith.name : '',
					filters: filters,
					columns: [],
					recordsPerPage: 0,
					viewType: 'dashboards',
					type: 'customer',
					userModified: true,
					search: '',
					config: startwith ? JSON.parse(startwith.config) : {}
				};
				dashboardCreationService.createDashboard(newDashboard, createDashboardCallback);
			};

			function createDashboardCallback(response, newDashboard) {
				if (response && response.status >= 400) {
					$timeout(function() {
						addDashboardScope.hasError = true;
						addDashboardScope.errorMessage = response.status === 409 ? '* Dashboard name already exists' : 'Unexpected server error';
					});
					return;
				}
				pendo.track('addDashboard', {
					name: newDashboard.reportName,
					parentName: newDashboard.baseReportName,
					structure: newDashboard.config.layout
				});
				var state = navigationService.getStateForDashboard({id: response.data.ndx, baseReportName: newDashboard.baseReportName});
				$state.go(state.sref, state.params);
				instance.close();
				addDashboardScope.$destroy();
			}

			addDashboardScope.onSave = function () {
				if ($scope.dashboard.title.trim() !== '' && $scope.dashboard.startwith !== '') {
					return true;
				}
				return false;
			};
		};

		$scope.$on('addNewDashboardDialog', $scope.addNewDashboardDialog);
	}
})();
